import { prefersReducedMotion } from "@mineoptics/brand/reduced-motion";

const KEY = "mineoptics:intro-seen";

/** How long the intro overlay covers the page, in seconds. */
export const INTRO_SECONDS = 1.15;

let decided: boolean | null = null;

/**
 * Whether this page load shows the intro: once per browser session, never
 * with reduced motion. Decided on first call and stable afterwards.
 */
export function shouldPlayIntro(): boolean {
  if (decided !== null) return decided;
  decided = false;
  if (typeof window === "undefined" || prefersReducedMotion()) return decided;
  try {
    if (!window.sessionStorage.getItem(KEY)) {
      window.sessionStorage.setItem(KEY, "1");
      decided = true;
    }
  } catch {
    // Storage is unavailable (private mode, blocked): skip the intro.
  }
  return decided;
}

let finishedAt = 0;

/** Seconds that on-load animations should wait so they start as the overlay lifts. */
export function introDelay(): number {
  if (!shouldPlayIntro()) return 0;
  if (!finishedAt) finishedAt = performance.now() + (INTRO_SECONDS - 0.35) * 1000;
  return Math.max(0, (finishedAt - performance.now()) / 1000);
}
